import React, { useEffect, useState, useRef, useContext } from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  Row,
  Spin,
  message,
  Select,
  Breadcrumb,
  Typography,
  Upload,
  Image,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import SimpleReactValidator from "simple-react-validator";
import { get_language, translate } from "../../../locale";
import { Link } from "react-router-dom";
import CustomDatePicker from "../../../components/Datepicker/CustomDatePicker";
import moment from "moment";
import UserServices from "../../../services/UserServices";
import { AdminContext } from "../../../providers/AdminContext";
import PrimaryButton from "../../../components/Buttons/PrimaryButton";
import previewImage from "../../../assets/images/icon_user.png";

const { Option } = Select;
const { Title, Text } = Typography;

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [loadingCountries, setLoadingCountries] = useState(true);
  const [sendingForm, setSendingForm] = useState(false);
  const [values, setValues] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    country_code: "",
    birth: "",
    identity_label: "",
    identity_value: "",
    biological_gender: "",
    phones: [],
    email: [],
    num_professional_registration: "",
    photo: "",
  });
  const [error, setError] = useState("");
  const [, forceUpdate] = useState();
  const { user, setProfile } = useContext(AdminContext);
  const [isProfessional, setIsProfessional] = useState(false);
  const [profileCompleted, setProfileCompleted] = useState(false);
  const [countries, setCountries] = useState([]);
  const [file, setFile] = useState(null);

  const doc_types = [
    {
      id: "",
      label: "Seleccione...",
    },
    {
      id: "dni",
      label: "DNI",
    },
  ];
  const genders = [
    {
      id: "",
      label: "Seleccione...",
    },
    {
      id: "nc",
      label: "No contesta",
    },
    {
      id: "m",
      label: "Masculino",
    },
    {
      id: "f",
      label: "Femenino",
    },
  ];
  const emailTargets = [
    { id: "trabajo", label: translate("Trabajo") },
    { id: "principal", label: translate("Principal") },
    { id: "privado", label: translate("Privado") },
    { id: "sin_etiqueta", label: translate("Sin etiqueta") },
    { id: "otro", label: translate("Otro") },
    { id: "personalizado", label: translate("Personalizado") },
  ];
  const phoneTargets = [
    { id: "movil", label: translate("Movil") },
    { id: "fax", label: translate("Fax") },
    { id: "trabajo", label: translate("Trabajo") },
    { id: "principal", label: translate("Principal") },
    { id: "privado", label: translate("Privado") },
    { id: "sin_etiqueta", label: translate("Sin etiqueta") },
    { id: "otro", label: translate("Otro") },
    { id: "personalizado", label: translate("Personalizado") },
  ];

  const disabled = () => !simpleValidator.current.allValid();

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      messages: {
        required: "Campo requerido",
      },
      validators: {
        date_older_than: {
          message: translate("Debe ser mayor a 18 años"),
          rule: function (val, params) {
            return (
              moment(val).diff(moment().subtract(params[0], "years"), "hours") <
              0
            );
          },
        },
      },
    })
  );

  useEffect(() => {
    if (user !== null && user !== undefined) {
      setIsProfessional(user.user.rol === "eira-professional");
      setProfileCompleted(
        user.first_name === "" ||
          user.last_name === "" ||
          user.birth === "" ||
          user.nationality === null ||
          user.nationality === ""
      );
    }
  }, [user]);

  useEffect(() => {
    loadProfile();
  }, []);

  const loadProfile = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await UserServices.getProfile();
      if (res.status >= 200 && res.status < 300) {
        const data = res.data.my_contact_info;
        setValues((v) => ({
          ...v,
          ...data,
          country_code:
            data.nationality?.code !== undefined ? data.nationality.code : "",
        }));
        setFile(data.photo);
        loadCountries(data.user.username);
      }
      setLoading(false);
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  };

  const loadCountries = async (username) => {
    setLoadingCountries(true);
    setError("");
    try {
      const res = await UserServices.getCountries(username);
      if (res.status >= 200 && res.status < 300) {
        setCountries(
          res.data.countries.map((i) => ({ id: i.code, label: i.name }))
        );
      }
      setLoadingCountries(false);
    } catch (e) {
      setError(e.message);
      setLoadingCountries(false);
    }
  };

  const onFinish = async () => {
    setSendingForm(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError(translate("Todos los campos son requeridos."));
      return;
    }
    try {
      const data = {
        ...values,
        birth: moment(values.birth).format("YYYY-MM-DD"),
      };
      const res = await UserServices.updateProfile(data);
      if (res) {
        if (res.status >= 200 && res.status < 300) {
          setProfile(res.data.message);
          message.success(translate("Los datos se actualizaron exitosamente."));
        } else {
          setError(translate("No se pudieron actualizar los datos."));
        }
        setSendingForm(false);
      } else {
        setError(
          translate("Ocurrió un problema procesando los datos del formulario.")
        );
      }
      setSendingForm(false);
      console.log(values);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setSendingForm(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleDatePickerChange = (value) => {
    simpleValidator.current.showMessageFor("birth");
    setValues((v) => ({ ...v, birth: value === null ? "" : value }));
  };

  const handleDatePickerBlur = (value) => {
    simpleValidator.current.showMessageFor("birth");
    setValues((v) => ({ ...v, birth: value === null ? "" : value }));
  };

  const handleTarget = (value, index, fieldname, field) => {
    setValues((v) => {
      const newPhone = v[fieldname];
      newPhone[index] = { ...newPhone[index], target: value };
      return {
        ...v,
        [fieldname]: newPhone,
      };
    });
  };

  const handlePhone = (e, index) => {
    const { value } = e.target;

    setValues((v) => {
      const newPhone = v.phones;
      newPhone[index] = { ...newPhone[index], number: value };
      return {
        ...v,
        phones: newPhone,
      };
    });
  };

  const handleEmail = (e, index) => {
    const { value } = e.target;

    setValues((v) => {
      const newEmail = v.emails;
      newEmail[index] = { ...newEmail[index], email: value };
      return {
        ...v,
        emails: newEmail,
      };
    });
  };

  const addRow = (name) => {
    const value =
      name === "phones"
        ? { number: "", target: "" }
        : { email: "", target: "" };
    setValues((v) => ({
      ...v,
      [name]: [...v[name], value],
    }));
    simpleValidator.current.showMessageFor(name);
  };

  const removeRow = (index, name) => {
    const newValue = values[name].filter((i, k) => k !== index);
    setValues((v) => ({ ...v, [name]: newValue }));
    simpleValidator.current.showMessageFor(name);
  };

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    console.log("getBase64", img);
    reader.readAsDataURL(img);
  };

  const uploadProps = {
    accept: "image/png, image/jpeg, image/jpg",
    name: "image",
    showUploadList: false,
    /*
    headers: {
      authorization: "authorization-text",
    }, */
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image must smaller than 2MB!");
      }
      return false;
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        if (info.file) {
          uploadFile(info.file);
          // Get this url from response in real world.
          getBase64(info.file, (url) => {
            setFile(url);
          });
        } else {
          uploadFile(null);
        }
        // console.log({ ...values, file: info.fileList[0].originFileObj });
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, (url) => {
          setFile(url);
        });
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const uploadFile = async (file) => {
    try {
      const response = await new Promise((resolve, reject) => {
        setValues((v) => ({ ...v, photo: file }));
        resolve({ status: 201 });
      });

      if (response.status === 201) {
        message.success(
          translate("La {0} se cargó exitosamente.", translate("imagen"))
        );
      } else if (response.status >= 200 && response.status < 300) {
        message.success(
          translate("La {0} se guardó exitosamente.", translate("imagen"))
        );
      } else if (response.data.message) {
        message.error(response.data.message);
      } else {
        message.error(response.statusText);
      }
    } catch (error) {
      console.log("error", error);
      setError(error.message);
    }
  };

  return (
    <>
      <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
        <Row>
          <Col className="gutter-row" span="24">
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/admin">{translate("Inicio")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{translate("Perfil")}</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        {isProfessional && profileCompleted && (
          <Row>
            <Col span="12" className="my-4" offset="6">
              <Alert
                message={translate("Datos requeridos")}
                description={translate(
                  "Para continuar utilizando la plataforma debe completar su perfil."
                )}
                type="error"
                showIcon
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col span="24" className="my-4">
            <Title level={2} className="text-center">
              {translate("Editar Perfil")}
            </Title>
          </Col>
        </Row>
        {!loading && (
          <>
            <Form
              initialValues={values}
              onFinish={onFinish}
              autoComplete="off"
              className="w-full"
            >
              <Row>
                <Col span="6" offset={9}>
                  {error && (
                    <Alert
                      message={error}
                      type="error"
                      className="mb-6 text-center"
                      closable
                      onClose={() => setError("")}
                    />
                  )}
                </Col>
              </Row>
              <Row justify="center" gutter={24} className="mb-4 mt-6">
                <Col span="12">
                  <div className="flex flex-col">
                    <div className="flex flex-row justify-center mb-4">
                      <Image
                        src={file ? file : previewImage}
                        preview={file ? true : false}
                        width={100}
                        height={100}
                      />
                    </div>

                    <div className="flex flex-row justify-center">
                      <Upload {...uploadProps}>
                        {(file == null || file == "") && (
                          <PrimaryButton className="px-10">
                            {translate("Subir foto")}
                          </PrimaryButton>
                        )}
                        {file && (
                          <PrimaryButton className="px-10">
                            {translate("Cambiar foto")}
                          </PrimaryButton>
                        )}
                      </Upload>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row justify="center" gutter={24}>
                <Col span="6">
                  <Form.Item>
                    <Text>{translate("Nombre")}*</Text>
                    <Input
                      placeholder="Nombre"
                      name="first_name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.first_name}
                    />
                    {simpleValidator.current.message(
                      "first_name",
                      values.first_name,
                      "required",
                      get_language === "es"
                        ? {
                            messages: {
                              required: "El campo Nombre es requerido",
                            },
                          }
                        : {}
                    )}
                  </Form.Item>
                  <Form.Item>
                    <Text>{translate("Segundo Nombre")}</Text>
                    <Input
                      placeholder={translate("Segundo Nombre")}
                      name="middle_name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.middle_name}
                    />
                  </Form.Item>
                  <Form.Item>
                    <Text>{translate("Apellido")}*</Text>
                    <Input
                      placeholder={translate("Apellido")}
                      name="last_name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.last_name}
                    />
                    {simpleValidator.current.message(
                      "last_name",
                      values.last_name,
                      "required",
                      get_language === "es"
                        ? {
                            messages: {
                              required: "El campo Apellido es requerido",
                            },
                          }
                        : {}
                    )}
                  </Form.Item>
                  <Form.Item>
                    <Text>{translate("Sexo")}</Text>
                    <Select
                      name="biological_gender"
                      onChange={(v) =>
                        handleChange({
                          target: { name: "biological_gender", value: v },
                        })
                      }
                      value={values.biological_gender}
                      className="w-full"
                    >
                      {genders.map((p, k) => (
                        <Option key={k} value={p.id}>
                          {p.label}
                        </Option>
                      ))}
                    </Select>
                    {simpleValidator.current.message(
                      "biological_gender",
                      values.biological_gender,
                      "required",
                      get_language === "es"
                        ? {
                            messages: {
                              required: "El campo sexo es requerido",
                            },
                          }
                        : {}
                    )}
                  </Form.Item>
                  <Form.Item>
                    <Text>{translate("País")}*</Text>
                    <Select
                      name="country_code"
                      placeholder="País"
                      onChange={(v) =>
                        handleChange({
                          target: { name: "country_code", value: v },
                        })
                      }
                      value={values.country_code}
                    >
                      {countries.map((p, k) => (
                        <Option key={k} value={p.id}>
                          {p.label}
                        </Option>
                      ))}
                    </Select>
                    {simpleValidator.current.message(
                      "country_code",
                      values.country_code,
                      "required",
                      get_language === "es"
                        ? {
                            messages: {
                              required: "El campo País es requerido",
                            },
                          }
                        : {}
                    )}
                  </Form.Item>
                </Col>
                <Col span="6">
                  <Form.Item>
                    <Text>{translate("Fecha de nacimiento")}*</Text>
                    <CustomDatePicker
                      wrapperClassName="border-custom_primary"
                      onChange={handleDatePickerChange}
                      onClickOutside={handleDatePickerBlur}
                      selected={
                        values.birth ? new Date(moment(values.birth)) : ""
                      }
                      maxDate={new Date(moment().subtract(18, "years"))}
                      locale={get_language}
                      format="DD/MM/YYYY"
                      placeholder={
                        get_language === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY"
                      }
                    />
                    {simpleValidator.current.message(
                      "birth",
                      values.birth,
                      "required|date_older_than:18"
                    )}
                  </Form.Item>
                  <Row gutter={8}>
                    <Col span="8">
                      <Form.Item>
                        <Text>{translate("Documento")}</Text>
                        <Select
                          name="identity_label"
                          onChange={(v) =>
                            handleChange({
                              target: { name: "identity_label", value: v },
                            })
                          }
                          value={values.identity_label}
                          className="w-full"
                        >
                          {doc_types.map((p, k) => (
                            <Option key={k} value={p.id}>
                              {p.label}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      <Form.Item>
                        <Text>{translate("Número")}</Text>
                        <Input
                          placeholder={translate("Número")}
                          name="identity_value"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.identity_value}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <div>
                    <Text>{translate("Teléfono")}</Text>
                    <Form.List name="phones">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map((field, index) => (
                            <div key={field.key} className="relative">
                              <div
                                style={{ width: "calc(100% - 32px)" }}
                                className="flex space-x-2 mb-6"
                              >
                                <Form.Item
                                  name={[field.name, "target"]}
                                  fieldKey={[field.key, "target"]}
                                  className="mb-0"
                                >
                                  <Select
                                    placeholder="Tipo"
                                    onChange={(e) =>
                                      handleTarget(e, index, "phones", field)
                                    }
                                  >
                                    {phoneTargets.map((i, k) => (
                                      <Option key={k} value={i.id}>
                                        {i.label}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  name={[field.name, "number"]}
                                  fieldKey={[field.key, "number"]}
                                  className="mb-0 flex-1"
                                >
                                  <Input
                                    placeholder="Teléfono"
                                    onChange={(e) => handlePhone(e, index)}
                                  />
                                </Form.Item>
                              </div>
                              <Button
                                shape="circle"
                                className="absolute right-0 bottom-1 bg-custom_primary text-white border-0 hover:bg-custom_primary hover:text-white focus:bg-custom_primary focus:text-white"
                                size="small"
                                onClick={(e) => {
                                  remove(field.name);
                                  removeRow(field.name, "phones");
                                }}
                              >
                                -
                              </Button>
                            </div>
                          ))}
                          {fields.length === 0 && add()}
                          <Button
                            className=" bg-custom_green text-white border-0 hover:bg-custom_green hover:text-white focus:bg-custom_green focus:text-white mb-6"
                            onClick={() => {
                              add();
                              addRow("phones");
                            }}
                          >
                            Agregar teléfono
                          </Button>
                        </>
                      )}
                    </Form.List>
                  </div>
                  <div>
                    <Text>
                      {translate("Email")} {console.log(values)}
                    </Text>

                    <Form.List name="emails">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map((field, index) => (
                            <div key={field.key} className="relative">
                              <div
                                style={{ width: "calc(100% - 32px)" }}
                                className="flex space-x-2 mb-6"
                              >
                                <Form.Item
                                  name={[field.name, "target"]}
                                  fieldKey={[field.key, "target"]}
                                  className="mb-0"
                                >
                                  <Select
                                    placeholder="Tipo"
                                    onChange={(e) =>
                                      handleTarget(e, index, "emails", field)
                                    }
                                  >
                                    {emailTargets.map((i, k) => (
                                      <Option key={k} value={i.id}>
                                        {i.label}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                                <Form.Item
                                  name={[field.name, "email"]}
                                  fieldKey={[field.key, "email"]}
                                  className="mb-0 flex-1"
                                >
                                  <Input
                                    placeholder="Email"
                                    onChange={(e) => handleEmail(e, index)}
                                  />
                                </Form.Item>
                              </div>
                              <Button
                                shape="circle"
                                className="absolute right-0 bottom-1 bg-custom_primary text-white border-0 hover:bg-custom_primary hover:text-white focus:bg-custom_primary focus:text-white"
                                size="small"
                                onClick={(e) => {
                                  remove(field.name);
                                  removeRow(field.name, "emails");
                                }}
                              >
                                -
                              </Button>
                            </div>
                          ))}
                          {fields.length === 0 && add()}
                          <Button
                            className=" bg-custom_green text-white border-0 hover:bg-custom_green hover:text-white focus:bg-custom_green focus:text-white"
                            onClick={() => {
                              add();
                              addRow("emails");
                            }}
                          >
                            Agregar email
                          </Button>
                        </>
                      )}
                    </Form.List>
                  </div>
                </Col>
              </Row>

              {/* {values.user?.role !== undefined &&
            values.user.rol === "eira-professional" && (
              <Row justify="center" gutter={24}>
                <Col span="6">
                  <Form.Item>
                    <Text>{translate("Nro. de Matrícula Profesional")}</Text>
                    <Input
                      placeholder="Nro. de Matrícula Profesional"
                      name="num_professional_registration"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.num_professional_registration}
                    />
                    {simpleValidator.current.message(
                      "num_professional_registration",
                      values.num_professional_registration,
                      "required",
                      get_language === "es"
                        ? {
                            messages: {
                              required:
                                "El campo Nro. de Matrícula Profesional es requerido",
                            },
                          }
                        : {}
                    )}
                  </Form.Item>
                </Col>
                <Col span="6"></Col>
              </Row>
            )} */}
              <Row justify="center" gutter={24} className="mb-4 mt-6">
                <Col>*{translate("Campos requeridos")}</Col>
              </Row>
              <Row justify="center" gutter={24}>
                <Col>
                  <Button
                    disabled={disabled() || sendingForm}
                    htmlType="submit"
                    type="primary"
                    className="bg-custom_primary"
                  >
                    {loading ? (
                      <Spin
                        indicator={
                          <LoadingOutlined style={{ color: "#666666" }} />
                        }
                      />
                    ) : (
                      "Guardar"
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
            <p className="mt-8 text-center border-2 border-black shadow-sm shadow-black lg:mx-32 sm:mx-16 p-4 rounded-lg">
              La información en esta pantalla puede ser utilizada para acceder a
              secciones de la plataforma o reportes de actividad de los
              pacientes. Declaro bajo juramento que la información proporcionada
              es veraz y que las cuentas de correo electrónico son de mi
              titularidad, asegurando que la información proporcionada no
              infringe ni viola derechos de terceros.
            </p>
          </>
        )}
      </div>
    </>
  );
};
const InputList = ({ field, onChange, onAdd, onRemove }) => {
  const handleChange = (e) => {
    if (onChange) onChange(e);
  };
  const handleAdd = () => {
    if (onAdd) onAdd();
  };
  const handleRemove = () => {
    if (onRemove) onRemove();
  };
  return (
    <div className="relative">
      <div style={{ width: "calc(100% - 32px)" }}>
        <Form.Item name={[field.name, "phone"]} fieldKey={[field.key, "phone"]}>
          <Select placeholder="Teléfono" onChange={handleChange}>
            {/* {phoneTargets.map((i, k) => (
              <Option key={k} value={i.id}>
                {i.label}
              </Option>
            ))} */}
          </Select>
        </Form.Item>
        <Form.Item name={[field.name, "phone"]} fieldKey={[field.key, "phone"]}>
          <Input placeholder="Teléfono" onChange={handleChange} />
        </Form.Item>
      </div>
      {onAdd && (
        <Button
          shape="circle"
          className="absolute right-0 bottom-1 bg-custom_green text-white border-0 hover:bg-custom_green hover:text-white focus:bg-custom_green focus:text-white"
          size="small"
          onClick={handleAdd}
        >
          +
        </Button>
      )}
      {onRemove && (
        <Button
          shape="circle"
          className="absolute right-0 bottom-1 bg-custom_primary text-white border-0 hover:bg-custom_primary hover:text-white focus:bg-custom_primary focus:text-white"
          size="small"
          onClick={handleRemove}
        >
          -
        </Button>
      )}
    </div>
  );
};
export default Profile;
